import React from 'react';
import styled from 'styled-components';
import Arrowright from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { withRouter } from 'react-router';
import { openRegrasMundoBModal } from './helpers';

export const MundoDrawer = ({ history }) => (
  <Wrapper>
    <DrawerButton onClick={openRegrasMundoBModal(history)}>
      <strong>regras do americanas mundo</strong>
      <Arrowright fill="#666" width="12px" height="12px" transform="rotate(270)" />
    </DrawerButton>
  </Wrapper>
);

const DrawerButton = styled.a`
  border: 0;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-top: 1px solid rgba(206, 204, 204, 0.4);
  padding: 10px 0px;
  color: #666;
  width: 100%;
  cursor: pointer;

  &:focus,
  &:active {
    border: 0;
    outline: 0;
  }

  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.md};
`;

const Wrapper = styled.div`
  padding: 0 15px;
  -webkit-font-smoothing: antialiased;
`;

export default withRouter(MundoDrawer);
